<template>
  <div>
    <canvas ref="chart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'
import deepObjectsMerge from '@/utils/deepObjectsMerge'

export default {
  name: 'CChartBarRounded',

  props: {
    datasets: {
      type: Array,
      default: () => [],
      required: true
    },
    options: Object,
    labels: {
      type: Array,
      default: () => [],
      required: true
    },
    type: {
      type: String,
      default: 'CChartBarRounded'
    }
  },

  data () {
    return {
      chart: null
    }
  },

  watch: {
    datasets () {
      this.update()
    }
  },

  mounted () {
    this.init()
  },

  computed: {
    computedDataPoints () {
      const dataPoints = []
      this.datasets.forEach(ds => {
        dataPoints.push(...ds.data)
      })
      return dataPoints
    },
    maxDataPoint () {
      return Math.max.apply(Math, this.computedDataPoints)
    },
    defaultOptions () {
      return {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: false
            }
          ],
          yAxes: [
            {
              display: false,
              ticks: {
                display: true,
                min: 0,
                suggestedMax: Math.ceil(4 * this.maxDataPoint / 3)
              }
            }
          ]
        }
      }
    },
    computedOptions () {
      if (this.options.scales.yAxes[0].ticks.stepSize > this.maxDataPoint) {
        delete this.options.scales.yAxes[0].ticks.stepSize
      }
      return deepObjectsMerge(this.defaultOptions, this.options || {})
    },
    config () {
      return {
        type: this.type,
        data: {
          labels: this.labels,
          datasets: this.datasets
        },
        options: this.computedOptions
      }
    }
  },

  methods: {
    init () {
      if (this.chart) {
        this.chart.destroy()
      }
      const ctx = this.$refs.chart.getContext('2d')
      this.chart = new Chart(ctx, this.config)
    },
    update () {
      if (!this.chart) return
      Object.assign(this.chart, this.config)
      this.chart.update(this.config)
    }
  }
}

</script>
